<app-portal-render [credential]="credential" [path]="path"></app-portal-render>